var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="service--section"> <div class="contain spaced-row row"> <div class="container--left"> <div class="title-section"> <div class="overall-score service"> <label>Service</label> <div class="overall-score-value">'+
((__t=( service ))==null?'':__t)+
'</div> </div> <div class="overall-score company"> <label>Company</label> <div class="overall-score-value">'+
((__t=( company ))==null?'':__t)+
'</div> </div> </div> <p>'+
((__t=( text ))==null?'':__t)+
'</p> </div> <div class="container--right"> <div class="comp--industry"> <div class="rank--section"> <label>Rank</label> <div class="rank--section_rank_value"> <span>'+
((__t=( rank ))==null?'':__t)+
'</span> </div> </div> <div class="score--section"> <label>Score</label> <div class="overall-score">'+
((__t=( total  ))==null?'':__t)+
'</div> </div> </div> <div class="comp--mark"> <label>Position among other services</label> <div id="'+
((__t=( service.slice(0,2) + rank ))==null?'':__t)+
'-dot-chart"> </div> </div> </div> </div> </section>';
}
return __p;
};
